<app-dashboard-option [categories]="['CELL']" [label]="'ROWS'" [information]="'PIXEL'">
  <div app-dashboard-option-content>
    <app-number [value]="cell.rows" (sendValue)="receiveValue($event)" [color]="color" [min]="1" [max]="200" [step]="5"></app-number>
  </div>
</app-dashboard-option>